/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 13,
    height: 21,
    viewBox: '0 0 13 21',
    data: '<path pid="0" _fill="#008cff" d="M8.357 0a4.55 4.55 0 00-3.283 1.398 4.81 4.81 0 00-1.36 3.375v8.59c0 1.58 1.25 2.864 2.786 2.864s2.786-1.284 2.786-2.863V8.406a.942.942 0 00-.929-.954.942.942 0 00-.929.954v4.958a.943.943 0 01-.928.954.943.943 0 01-.929-.954V4.773c0-.765.29-1.484.817-2.025a2.729 2.729 0 011.969-.839c1.536 0 2.786 1.285 2.786 2.863v9.546c0 2.632-2.083 4.773-4.643 4.773a4.55 4.55 0 01-3.283-1.398 4.81 4.81 0 01-1.36-3.375V4.773a.942.942 0 00-.929-.955.942.942 0 00-.928.955v9.545c0 1.785.676 3.463 1.904 4.725A6.369 6.369 0 006.5 21c3.584 0 6.5-2.997 6.5-6.682V4.773C13 2.14 10.917 0 8.357 0z"/>'
  }
})
